package com.exura.features.legacyplans.domain.model

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

@Serializable
data class AnswerWindow(
    val startFrom: LocalDateTime,
    val endAt: LocalDateTime,
)
